import { useEffect, useState } from 'react'

import { MiniButton } from './mini-button'

/** Copies and confirms in place — the "Copy" next to every DNS record. */
export function CopyButton({
	value,
	label = 'Copy',
	tone = 'ghost',
}: {
	value: string
	label?: string
	tone?: 'ghost' | 'accent'
}) {
	const [copied, setCopied] = useState(false)

	useEffect(() => {
		if (!copied) {
			return
		}
		const id = window.setTimeout(() => setCopied(false), 1600)
		return () => window.clearTimeout(id)
	}, [copied])

	return (
		<MiniButton
			tone={tone}
			onClick={() => {
				// Optimistic "✓ Copied": clipboard access only fails on insecure
				// contexts or odd embeds, not worth a failure state on a copy button.
				void navigator.clipboard?.writeText(value)
				setCopied(true)
			}}
		>
			{copied ? '✓ Copied' : label}
		</MiniButton>
	)
}
